import { createContext, useContext } from "react";

// F168: cliente da tela de detalhes em que a equipe configura o protocolo. null = o próprio cliente na conta dele.
export const FilingCustomerContext = createContext(null);

export const useFilingCustomerId = () => useContext(FilingCustomerContext);
